import { RUN_STATUSES } from "utils/constants";

/**
 * An awaiting run on a screen (confirmation, tarif, …) still has something
 * to show. The generic "En attente" chrome is only for screenless waits.
 */
export const shouldKeepPublishedScreen = ({
  heldVersion,
  status,
  showProcessing,
  hasFormFields,
}) => {
  if (heldVersion == null) return false;
  if (showProcessing) return true;
  if (status === RUN_STATUSES.RUNNING) return true;
  if (status === RUN_STATUSES.AWAITING) return true;
  if (status === RUN_STATUSES.FAILED && hasFormFields) return true;
  return false;
};
